import { render, staticRenderFns } from "./PopupCampaign.vue?vue&type=template&id=6ebb2b82&scoped=true&"
import script from "./PopupCampaign.vue?vue&type=script&lang=js&"
export * from "./PopupCampaign.vue?vue&type=script&lang=js&"
import style0 from "./PopupCampaign.vue?vue&type=style&index=0&id=6ebb2b82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebb2b82",
  null
  
)

export default component.exports